// extracted by mini-css-extract-plugin
var _1 = "StackCard_actionButton__1212f";
var _2 = "StackCard_badge__34598";
var _3 = "StackCard_feedbackIcon__17427";
var _4 = "StackCard_itemLabel__161e9";
var _5 = "StackCard_itemMask__be9e5";
var _6 = "StackCard_selected__980a3";
var _7 = "StackCard_stackCard__9810d";
var _8 = "StackCard_stackItem__6b2db";
var _9 = "StackCard_stackWrapper__cb6d3";
var _a = "StackCard_textInner__881d6";
export { _1 as "actionButton", _2 as "badge", _3 as "feedbackIcon", _4 as "itemLabel", _5 as "itemMask", _6 as "selected", _7 as "stackCard", _8 as "stackItem", _9 as "stackWrapper", _a as "textInner" }
